import "src/config/i18nConfig.ts";
import "src/config/dayjsConfig.ts";
import "src/config/highchartsConfig.ts";
import "src/config/mapboxConfig.ts";
import React from "react";
import ReactDOM from "react-dom/client";
import "src/styles/css/index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./legacyViews/js/index";
import "@fortawesome/fontawesome-pro/css/all.css";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { applyLocalSettings } from "./localSettings/utils";
import { setupInitialBackgroundMessageEventHandler } from "./notifications/firebaseMessaging";
import { setupSentry } from "./setupSentry";
import { applyDomManipulationWorkaround } from "./utils/domManipulationWorkaround";
import { LicenseInfo as DataGridLicenseInfo } from "@mui/x-data-grid-pro";
import { library as fontawesomeLibrary } from "@fortawesome/fontawesome-svg-core";

setupSentry();

DataGridLicenseInfo.setLicenseKey(
	"db096eed815b7d8ead7130b1001d4b83Tz03MjgyMixFPTE3MjM3OTgzMDgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=",
);

applyLocalSettings(false);
applyDomManipulationWorkaround();

fontawesomeLibrary.add(far);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
setupInitialBackgroundMessageEventHandler();
